import { Megaphone, QrCode, TrendingUp } from "lucide-react";
import InfoPage from "./InfoPage";

export default function Marketing() {
  return (
    <InfoPage
      testid="marketing-page"
      eyebrow="Marketing Toolkit"
      title="Fill your line — every service, every city"
      description="Done-for-you social posts, branded QR codes, and a loyalty engine that turns first-time tasters into weekly regulars. Built to fit into your service, not slow it down."
      features={[
        {
          testid: "social-templates",
          icon: <Megaphone className="h-5 w-5" />,
          title: "Social post templates",
          description:
            "Drop-in Instagram and TikTok templates tailored to your menu, photographed on your truck. One click, one post, full caption.",
        },
        {
          testid: "branded-qr",
          icon: <QrCode className="h-5 w-5" />,
          title: "Branded QR menus",
          description:
            "Print-ready QR codes that route customers to your live menu, today's location, and ordering — colored in your truck's palette.",
        },
        {
          testid: "loyalty",
          icon: <TrendingUp className="h-5 w-5" />,
          title: "Loyalty & repeat-visit insights",
          description:
            "See who's coming back, what they order, and which neighborhoods convert. Trigger automated rewards without lifting a finger.",
        },
      ]}
      ctaPrimary={{ label: "Start free", to: "/register" }}
      ctaSecondary={{ label: "Book a demo", to: "/#contact" }}
    />
  );
}
